<template>
	<!-- height attr seems to not have any effect on AppDialog? -->
	<AppDialog ref="dialog_container" dialogName="DeleteBlockDialog" width="500px">
		<Col class="dialog-title flex-centerize text-align-center mt-4">
			<AppIcon name="broom" class="broom mt-5"></AppIcon>
			<span class="mt-3">Reset chat?</span>
		</Col>
		<h3 class="flex-centerize text-align-center mb-7">This will delete the conversation</h3>
		<div class="bottom-of-dialog">
			<PrimaryButton class="reset-convs-btns reset-btn" @click="reset"> Reset </PrimaryButton>
			<div class="reset-convs-btns cancel-btn mt-2" @click="close">Cancel</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import { deleteNode } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'ResetConvApiDocDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object } },
	methods: {
		...mapActionsShorthand({ deleteNode }),
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		async reset() {
			this.dialogPromiseHandlers.resolve(true);
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.rest-conv-block-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
}

.bottom-of-dialog {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1.5rem;
}

.reset-convs-btns {
	border: none !important;
	margin-bottom: 0.5rem;
}
.cancel-btn {
	text-decoration: underline;
	cursor: pointer;
}
.reset-btn {
	background: #5858ec 0% 0% no-repeat padding-box;
	border-radius: 7px;
	font-size: 16px;
	letter-spacing: 0px;
	color: #ffffff;
	opacity: 1;
	width: 120px;
	height: 40px;
}
</style>
